import { render } from "./SkeletonView.vue?vue&type=template&id=b0a4952e"
import script from "./SkeletonView.vue?vue&type=script&lang=js"
export * from "./SkeletonView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__